module.exports = __webpack_public_path__ + "media/images/icons/icn_036-7fa47f8c332dc940e8df7dc14998585a.svg";